/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seats: NonNullable<unknown> }} Cost_Calc_Team_SupportsInputs */



/**
* | output |
* | --- |
* | "Team plan supports {seats} users" |
*
* @param {Cost_Calc_Team_SupportsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cost_calc_team_supports = /** @type {((inputs: Cost_Calc_Team_SupportsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cost_Calc_Team_SupportsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Team-Plan unterstützt ${i?.seats} Nutzer`)
	return /** @type {LocalizedString} */ (`Team plan supports ${i?.seats} users`)
});